import React from "react";
import './Sticker.css';

const Sticker = (props) => {

  return(
    <div className={"sticker " + props.value.position + " " + props.value.shape + (props.value.img===""?" text":" img")} 
      style={props.value.img===""?{backgroundColor:props.value.bgColor,color:props.value.textColor}:{}}>
      {(props.value.img==="")?props.value.label:
        <img id="sticker-img" src={props.value.img} alt={props.value.img} />
      }
    </div>
  )
};

export default Sticker;